import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { memberActions } from '../../data/memberActions';
export function ActionsSection() {
  return <section id="demarches" className="border-t border-line bg-white py-20 lg:py-24" data-id="element-112" data-mp="1nq9yp8pduoxj">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-113" data-mp="1sns10g8wa5wk">
        <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-114" data-mp="1wpdhebkn12bi">
          <div className="max-w-xl" data-id="element-115" data-mp="zyl1bdxpfa9q">
            <h2 className="ffp-display text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-116" data-mp="zznqnhfdp4nj">Mes démarches</h2>
            <p className="mt-3 text-[16px] leading-relaxed text-ink/65" data-id="element-117" data-mp="14yquwznjb6ug">
              Tout ce qui se règle en ligne, sans courrier ni délai d’instruction.
            </p>
          </div>
          <a href="#espaces" className="ffp-focus inline-flex items-center gap-2 text-[14px] font-semibold text-navy" data-id="element-118" data-mp="1dq9b3akhdmnj">
            Voir toutes les démarches
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-119" data-mp="l96n9sj6o4o0" />
          </a>
        </div>

        <ul className="mt-10 border-t border-line" data-id="element-120" data-mp="26bpney0u5dpv">
          {memberActions.map(action => <li key={action.id} className="border-b border-line" data-id="element-121" data-mp="21bl7pa7r4n0p">
              <a href="#espaces" className="ffp-focus group flex flex-col gap-2 py-6 transition-colors duration-150 ease-soft hover:bg-cloud sm:flex-row sm:items-center sm:gap-8" data-id="element-122" data-mp="21eh4gv7v55nk">
                <span className="ffp-display w-44 shrink-0 text-[12px] font-bold uppercase tracking-wider text-azure" data-id="element-123" data-mp="1mnqd1oa6o8kz">
                  {action.meta}
                </span>
                <span className="flex-1" data-id="element-124" data-mp="1inzpdtfye8ko">
                  <span className="ffp-display block text-[19px] font-bold text-ink lg:text-[21px]" data-id="element-125" data-mp="1dlqyd2mn5gl7">
                    {action.title}
                  </span>
                  <span className="mt-1 block text-[15px] leading-relaxed text-ink/65" data-id="element-126" data-mp="380jown8o3h6a">{action.description}</span>
                </span>
                <ArrowRightIcon className="h-5 w-5 shrink-0 text-navy transition-transform duration-150 ease-soft group-hover:translate-x-1" aria-hidden="true" data-id="element-127" data-mp="33170hy25e21l" />
              </a>
            </li>)}
        </ul>
      </div>
    </section>;
}